import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});
